import styled from '@emotion/styled';

export const MainBlock = styled.div<{ disabled?: boolean }>`
  cursor: ${({ disabled }) => {
    return disabled ? 'not-allowed' : 'unset';
  }};
`;
